/* tslint:disable:no-console */
import { Injectable } from '@angular/core';

import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { ApplicationInsightsService } from '../../application-insights.service';

interface ILoggerService {
  log: (message: unknown) => void;

  info: (
    name: string,
    customProperties?: Record<string, unknown>
  ) => void;
  /**
   * Sends message to console.warn.
   */
  warn: (message: unknown) => void;
  /**
   * Sends message to console.error.
   */
  error: (message: unknown) => void;
}

@Injectable({
  providedIn: 'root',
})
export class LoggerService implements ILoggerService {
  /**
   * Sends message to console.log.
   */
  log(message: unknown) {
    console.log(message);
  }

  /**
   * Sends message to console.info.
   */
  info(
    name: string,
    customProperties?: Record<string, unknown>
  ) {
    console.info(name);
    console.info(customProperties);
  }

  /**
   * Sends message to console.warn.
   */
  warn(message: unknown) {
    console.warn(message);
  }

  /**
   * Sends message to console.error.
   */
  error(message: unknown) {
    console.error(message);
  }
}

@Injectable()
export class AzureLoggerService implements ILoggerService {
  constructor(
    private readonly appInsightsService: ApplicationInsightsService
  ) {}

  /**
   * Sends message to console.log.
   */
  log(message: unknown) {
    console.log(message);
  }

  /**
   * Sends message to console.info and to Application Insights
   * Use like logger.info('my page event', { 'request Url': this.router.url})
   */
  info(
    name: string,
    customProperties?: Record<string, unknown>
  ) {
    customProperties.source = 'angular';
    this.appInsightsService.trackEvent({ name }, customProperties);
    console.log(name);
    console.log(customProperties);
  }

  /**
   * Sends message to console.warn and to Application Insights as a Warning
   */
  warn(message: unknown) {
    this.appInsightsService.trackException({
      exception: message as Error,
      severityLevel: SeverityLevel.Warning,
      properties: {
        source: 'angular',
      },
    });
    console.warn(message);
  }

  /**
   * Sends message to console.error and sends message to Application Insights as an Error
   */
  error(message: unknown) {
    this.appInsightsService.trackException({
      exception: message as Error,
      severityLevel: SeverityLevel.Error,
      properties: {
        source: 'angular',
      },
    });
    console.error(message);
  }
}
